import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChefHat } from 'lucide-react';
import ScheduleCard from './ScheduleCard';

const SchedulesList = ({ 
  filteredSchedules, 
  statusConfig, 
  handleMarkReady, 
  setSelectedSchedule, 
  updateStatusMutation,
  formatTimeRange 
}) => {
  const { t } = useTranslation();

  if (filteredSchedules.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <ChefHat className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600 text-lg mb-2">
          {t('customerMeals.noMealsFound', 'No meals found for the selected date and filters')}
        </p>
        <p className="text-gray-500">
          {t('tryDifferentFilters', 'Try adjusting your filters or selecting a different date')}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {filteredSchedules.map((schedule) => (
        <ScheduleCard
          key={schedule.id}
          schedule={schedule}
          statusConfig={statusConfig}
          handleMarkReady={handleMarkReady}
          setSelectedSchedule={setSelectedSchedule}
          updateStatusMutation={updateStatusMutation}
          formatTimeRange={formatTimeRange}
        />
      ))}
    </div>
  );
};

export default SchedulesList;
